import { DialogService, GridAction } from '@eforall/dashboard';
import { SessionRow } from '../sessions-view.part';
import { SessionAttendanceDialog } from '../attendance-dialog/attendance.dialog';
import { EventDialog } from 'ui/widget';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';

export function getActions(dialogService: DialogService, areaService: AcceleratorAreaService) {

	const actions: GridAction<SessionRow>[] = [
		{
			label: `Edit Attendance`,
			iconClass: 'fa-regular fa-pencil',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const accSessionId = rows[0]?.accSessionId;
				const specialists = rows[0]?.specialists;
				if (accSessionId) {
					await dialogService.showCustom(SessionAttendanceDialog, { data: { accSessionId, specialistNames: specialists } }, 900, 700);
					await areaService.reloadData();
				}
			}
		},
		{
			iconClass: 'fa-regular fa-calendar-lines',
			label: 'Open Event',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const eventId = rows[0]?.eventId;
				if (eventId) {
					await dialogService.showCustom(EventDialog, { data: { eventId } }, 900, 700);
					await areaService.reloadData();
				}
			}
		},
		{
			iconClass: 'fa-regular fa-link-horizontal',
			label: 'Get Tool Link',
			isEnabled: rows => !!rows.length,
			execute: async rows => { console.log(`Action clicked!`, rows) }
		},
	];

	return actions;
}